<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="isFetchingData" :can-cancel="false"></b-loading>
        <div class="columns">
            <div class="column is-4">
                <h5 class="title is-5">TOP 3 w/ highest profit 💰 ({{this.month}}/{{this.year}})</h5>
                <hr />
                <div v-show="top3UserAgents.top1.monthlyTotalProfit == 0 && top3UserAgents.top2.monthlyTotalProfit == 0 && top3UserAgents.top3.monthlyTotalProfit == 0">
                    <center>
                        <i>{{noDataFound}}</i>
                    </center>
                </div>
                <div v-show="top3UserAgents.top1.monthlyTotalProfit != 0">
                    <div class="level">
                        <div class="level-left">
                            <img class="dashboard-image" :src="`${payrollApi}api/employees/profile-image/${top3UserAgents.top1.employeeId}`" width="60" height="60" /> &nbsp;
                            <b-tag type="is-success">1st 🥇</b-tag>
                            &nbsp;{{top3UserAgents.top1.userAgentName}}
                        </div>
                        <div class="level-right">
                            <strong>
                                <p title="Profit">{{top3UserAgents.top1.monthlyTotalProfit}}</p>
                            </strong>
                        </div>
                    </div>
                </div>
                <div v-show="top3UserAgents.top2.monthlyTotalProfit != 0">
                    <div class="level">
                        <div class="level-left">
                            <img class="dashboard-image" :src="`${payrollApi}api/employees/profile-image/${top3UserAgents.top2.employeeId}`" width="60" height="60" /> &nbsp;
                            <b-tag type="is-default">2nd</b-tag>
                            &nbsp;{{top3UserAgents.top2.userAgentName}}
                        </div>
                        <div class="level-right">
                            <strong>
                                <p title="Profit">{{top3UserAgents.top2.monthlyTotalProfit}}</p>
                            </strong>
                        </div>
                    </div>
                </div>
                <div v-show="top3UserAgents.top3.monthlyTotalProfit != 0">
                    <div class="level">
                        <div class="level-left">
                            <img class="dashboard-image" :src="`${payrollApi}api/employees/profile-image/${top3UserAgents.top3.employeeId}`" width="60" height="60" /> &nbsp;
                            <b-tag type="is-default">3rd</b-tag>
                            &nbsp;{{top3UserAgents.top3.userAgentName}}
                        </div>
                        <div class="level-right">
                            <strong>
                                <p title="Profit">{{top3UserAgents.top3.monthlyTotalProfit}}</p>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-8">
                <h5 class="title is-5">Sales Agents Summary</h5>
                <hr />
                <b-table :data="userAgents" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true">
                    <template slot-scope="item">
                        <b-table-column field="profile" class="table-column-content-is-small">
                            <div class="level">
                                <div class="level-left">
                                    <img class="dashboard-image" :src="`${payrollApi}api/employees/profile-image/${item.row.employeeId}`" width="30" height="30" /> &nbsp;{{item.row.userAgentName}}
                                </div>
                            </div>
                        </b-table-column>
                        <b-table-column field="weeklyquota" class="table-column-content-is-small" label="Weekly quota">
                            <span style="float:right">{{item.row.weeklyQuota}}</span>
                        </b-table-column>
                        <b-table-column field="weeklyprofit" class="table-column-content-is-small" label="Weekly profit">
                            <span style="float:right">{{item.row.weeklyTotalProfit}}</span>
                        </b-table-column>
                        <b-table-column field="montlyquota" class="table-column-content-is-small" label="Monthly quota">
                            <span style="float:right">{{item.row.monthlyQuota}}</span>
                        </b-table-column>
                        <b-table-column field="monthlyprofit" class="table-column-content-is-small" label="Monthly profit">
                            <span style="float:right">{{item.row.monthlyTotalProfit}}</span>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import numeral from 'numeral'
import axios from 'axios'

export default {
  props: ['year', 'month', 'isAdaptive'],
  data: () => ({
    userAgents: [],
    noDataFound: 'Please wait...',
    top3UserAgents: {
      top1: {
        employeeId: 0,
        userAgentName: '',
        monthlyTotalProfit: 0
      },
      top2: {
        employeeId: 0,
        userAgentName: '',
        monthlyTotalProfit: 0
      },
      top3: {
        employeeId: 0,
        userAgentName: '',
        monthlyTotalProfit: 0
      }
    },
    payrollApi: '',
    isFetchingData: false
  }),
  watch: {
    month() {
      if (this.month) {
        this.getTotalProfitOfAgents()
      }
    },
    year() {
      if (this.year) {
        this.getTotalProfitOfAgents()
      }
    },
    isAdaptive() {
      this.getMonthlyQuotaAndProfit()
    }
  },
  created() {
    this.getPayrollHostAndPort()
    this.getTotalProfitOfAgents()
  },
  methods: {
    getTotalProfitOfAgents() {
      this.getUserAgentsTotal()
      this.getTop3UserAgents()
    },
    getUserAgentsTotal() {
      this.isFetchingData = true
      axios
        .get(
          `api/dashboard/user-agents-total-profit-by-year/${this.isAdaptive}/${this.year}/${
            this.month
          }`
        )
        .then(response => {
          response.data.forEach(u => {
              u.weeklyQuota = numeral(u.weeklyQuota).format('0,0.00')
              u.monthlyQuota = numeral(u.monthlyQuota).format('0,0.00')
              u.weeklyTotalProfit = numeral(u.weeklyTotalProfit).format('0,0.00')
              u.monthlyTotalProfit = numeral(u.monthlyTotalProfit).format('0,0.00')
          });
        
          this.userAgents = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => (this.isFetchingData = false))
    },
    getTop3UserAgents() {
      this.isFetchingData = true
      axios
        .get(
          `api/dashboard/top-3-user-agents-with-highest-total-profit-by-month-year/${this.isAdaptive}/${
            this.year
          }/${this.month}`
        )
        .then(response => {
          this.top3UserAgents = response.data
          this.top3UserAgents.top1.monthlyTotalProfit = numeral(this.top3UserAgents.top1.monthlyTotalProfit).format('0,0.00')
          this.top3UserAgents.top2.monthlyTotalProfit = numeral(this.top3UserAgents.top2.monthlyTotalProfit).format('0,0.00')
          this.top3UserAgents.top3.monthlyTotalProfit = numeral(this.top3UserAgents.top3.monthlyTotalProfit).format('0,0.00')
          if (!this.top3UserAgents.top1) {
            this.top3UserAgents.top1 = {
              employeeId: 0,
              userAgentName: '',
              monthlyTotalProfit: 0
            }
          }
          if (!this.top3UserAgents.top2) {
            this.top3UserAgents.top2 = {
              employeeId: 0,
              userAgentName: '',
              monthlyTotalProfit: 0
            }
          }
          if (!this.top3UserAgents.top3) {
            this.top3UserAgents.top3 = {
              employeeId: 0,
              userAgentName: '',
              monthlyTotalProfit: 0
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          if (!this.top3UserAgents) {
            this.noDataFound = 'No data found'
          }
          this.isFetchingData = false
        })
    },
    getPayrollHostAndPort() {
      axios
        .get(`api/settings/payroll-api`)
        .then(response => {
          this.payrollApi = response.data
        })
        .catch(error => console.log(error))
    }
  }
}
</script>

<style>
label {
  font-size: 5px;
}
.dashboard-image {
  border-radius: 50%;
}
</style>
